
import { mapState, mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.ReviewDetailPanelPc',
  name: 'ReviewDetailPanelPc',
  props: {
    review: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('session', ['isLoggedIn']),
    showLikeSection() {
      return (
        this.isLoggedIn &&
        (this.reviewSettings.use_likes_count ||
          this.reviewSettings.use_comments)
      );
    }
  }
};
